import RegistrationWrapper from './RegistrationWrapper';
export default RegistrationWrapper;
